var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideoAccepted = function SvgVideoAccepted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3008 6.99475V4.30899C13.3008 3.88694 12.9644 3.54163 12.5532 3.54163H3.58094C3.16971 3.54163 2.83325 3.88694 2.83325 4.30899V11.9826C2.83325 12.4046 3.16971 12.75 3.58094 12.75H12.5532C12.9644 12.75 13.3008 12.4046 13.3008 11.9826V9.29683L16.2916 12.3663V3.92531L13.3008 6.99475Z",
    fill: "#5D9C62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36859 14.5201L4.7223 14.8741L5.07602 14.5201L11.6871 7.90293L12.039 7.55079L11.6884 7.1974L10.5232 6.02286L10.1695 5.66632L9.81449 6.02161L4.72162 11.1191L2.93499 9.33776L2.58127 8.98509L2.22824 9.33844L1.06303 10.5047L0.709963 10.8581L1.06303 11.2115L4.36859 14.5201Z",
    fill: "#5D9C62",
    stroke: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoAccepted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-accepted.84ec1447.svg";
export { ForwardRef as ReactComponent };